export const ALLOWED_BY_DEFAULT = 'ALLOW_BY_DEFAULT';
export const MUST_REVIEW = 'MUST_REVIEW';
